import NotificationsSection from './NotificationsSection';

export default NotificationsSection;